export const shippingPath = (keyPath) => {
  return {
    SHIPPING_PATH: `shippingDetails[${keyPath}]`,
  };
};

export const commonPath = (pIndex, colIndex, colChildIndex) => {
  return {
    COMPANY_DETAILS: `templateJsonSchema[${pIndex}].columns[${colIndex}][${colChildIndex}].value`,
    COMPANY_DETAILS_CHECKBOX: `templateJsonSchema[${pIndex}].columns[${colIndex}][${colChildIndex}]`,
  };
};

export const colourPath = (pIndex, colIndex, childIndex) => {
  return {
    FETCH_SINGLE_PACKED_UNITS: `templateJsonSchema[${pIndex}].sigularPackedUnits`,
    SINGLE_PACKED_UNIT: {
      SIZE_PATH: `templateJsonSchema[${pIndex}].sigularPackedUnits[${colIndex}].singularPackedRows[${childIndex}].size`,
      LENGTH_PATH: `templateJsonSchema[${pIndex}].sigularPackedUnits[${colIndex}].singularPackedRows[${childIndex}].length`,
      QUANTITY_PATH: `templateJsonSchema[${pIndex}].sigularPackedUnits[${colIndex}].singularPackedRows[${childIndex}].quantity`,
      BEFORE_DISCOUNT_PATH: `templateJsonSchema[${pIndex}].sigularPackedUnits[${colIndex}].singularPackedRows[${childIndex}].beforeDiscPrice`,
      DISCOUNT_PATH: `templateJsonSchema[${pIndex}].sigularPackedUnits[${colIndex}].singularPackedRows[${childIndex}].discount`,
      AFTER_DISCOUNT_PATH: `templateJsonSchema[${pIndex}].sigularPackedUnits[${colIndex}].singularPackedRows[${childIndex}].afterDiscPrice`,
      COMMON_PATH: `templateJsonSchema[${pIndex}].sigularPackedUnits[${colIndex}]`,
    },
    MULTIPLE_SINGLE_SIZE_PACKED_UNITS: {
      SIZE_PATH: `templateJsonSchema[${pIndex}].multiplePacks[${colIndex}].multiplePackedRows[${childIndex}].size`,
      LENGTH_PATH: `templateJsonSchema[${pIndex}].multiplePacks[${colIndex}].multiplePackedRows[${childIndex}].length`,
      PACK_RATIO: `templateJsonSchema[${pIndex}].multiplePacks[${colIndex}].multiplePackedRows[${childIndex}].packRatio`,
      PACK_QUANTITY: `templateJsonSchema[${pIndex}].multiplePacks[${colIndex}].multiplePackedRows[${childIndex}].packsQuantity`,
      TOTAL_UNITS: `templateJsonSchema[${pIndex}].multiplePacks[${colIndex}].multiplePackedRows[${childIndex}].totalUnits`,
      BEFORE_DESCOUNT: `templateJsonSchema[${pIndex}].multiplePacks[${colIndex}].multiplePackedRows[${childIndex}].beforeDiscPrice`,
      DISCOUNT: `templateJsonSchema[${pIndex}].multiplePacks[${colIndex}].multiplePackedRows[${childIndex}].discount`,
      AFTER_DISCOUNT: `templateJsonSchema[${pIndex}].multiplePacks[${colIndex}].multiplePackedRows[${childIndex}].afterDiscPrice`,
      COMMON_PATH: `templateJsonSchema[${pIndex}].multiplePacks[${colIndex}]`,
    },
    MULTI_SIZE_PACKED_UNITS: {
      SIZE_PATH: `templateJsonSchema[${pIndex}].multipleTotalPacks[${colIndex}].multipleTotalPackedRows[${childIndex}].size`,
      LENGTH_PATH: `templateJsonSchema[${pIndex}].multipleTotalPacks[${colIndex}].multipleTotalPackedRows[${childIndex}].length`,
      PACK_RATIO: `templateJsonSchema[${pIndex}].multipleTotalPacks[${colIndex}].multipleTotalPackedRows[${childIndex}].packRatio`,
      PACK_QUANTITY: `templateJsonSchema[${pIndex}].multipleTotalPacks[${colIndex}].totalPacks`,
      TOTAL_UNITS: `templateJsonSchema[${pIndex}].multipleTotalPacks[${colIndex}].multipleTotalPackedRows[${childIndex}].totalUnits`,
      BEFORE_DESCOUNT: `templateJsonSchema[${pIndex}].multipleTotalPacks[${colIndex}].multipleTotalPackedRows[${childIndex}].beforeDiscPrice`,
      DISCOUNT: `templateJsonSchema[${pIndex}].multipleTotalPacks[${colIndex}].multipleTotalPackedRows[${childIndex}].discount`,
      AFTER_DISCOUNT: `templateJsonSchema[${pIndex}].multipleTotalPacks[${colIndex}].multipleTotalPackedRows[${childIndex}].afterDiscPrice`,
      COMMON_PATH: `templateJsonSchema[${pIndex}].multipleTotalPacks[${colIndex}]`,
    },
    MULTI_DESTINATION_PACKED_UNITS: {
      SIZE_PATH: `templateJsonSchema[${pIndex}].ratioPacks[${colIndex}].leftColumn[${childIndex}].size`,
      LENGTH_PATH: `templateJsonSchema[${pIndex}].ratioPacks[${colIndex}].leftColumn[${childIndex}].length`,
      PACK_RATIO: `templateJsonSchema[${pIndex}].ratioPacks[${colIndex}].leftColumn[${childIndex}].packRatio`,
      BEFORE_DESCOUNT: `templateJsonSchema[${pIndex}].ratioPacks[${colIndex}].leftColumn[${childIndex}].beforeDiscPrice`,
      DISCOUNT: `templateJsonSchema[${pIndex}].ratioPacks[${colIndex}].leftColumn[${childIndex}].discount`,
      AFTER_DISCOUNT: `templateJsonSchema[${pIndex}].ratioPacks[${colIndex}].leftColumn[${childIndex}].afterDiscPrice`,
      ADDING_ROW: `templateJsonSchema[${pIndex}].ratioPacks[${colIndex}].leftColumn[${childIndex}]`,
      COPY_MODAL: `templateJsonSchema[${pIndex}].ratioPacks[${colIndex}]`,
      DESTINATION: `templateJsonSchema[${pIndex}].ratioPacks[${colIndex}].rigthColumn[${childIndex}].destination`,
      QTY: `templateJsonSchema[${pIndex}].ratioPacks[${colIndex}].rigthColumn[${childIndex}].packsQuantity`,
      TOTAL_DESTINATION_TOTAL_UNIT: `templateJsonSchema[${pIndex}].ratioPacks[${colIndex}].rigthColumn[${childIndex}].totalUnits`,
      TOTAL_DESTINATION_PACKING_QTY: `templateJsonSchema[${pIndex}].ratioPacks[${colIndex}].rigthColumn[${childIndex}].packsQuantity`,
      ADDING_RIGHT_ROW: `templateJsonSchema[${pIndex}].ratioPacks[${colIndex}].rigthColumn[${childIndex}]`,
      COMMON_PATH: `templateJsonSchema[${pIndex}].ratioPacks[${colIndex}]`,
    },
  };
};
